import { Suspense } from 'react'
import { PageNote } from '@/components/PageNote'
import { LogOut } from 'lucide-react'
import { Link, Outlet } from 'react-router'
import logoWhite from '@/assets/brand/Logo_White.png'
import { useAuth } from '@/auth/useAuth'
import { FounderMfaGate } from '@/features/founder/FounderMfaGate'

/**
 * Slim founder-portal shell: a header with the VONK logo and a logout button.
 *
 * spec-36 §5.1: the tabbed navigation is gone — the whole founder environment
 * is one scrollable page under `/founder`. Two-factor authentication is
 * mandatory for the entire portal, so we wrap the routed content in
 * `<FounderMfaGate/>` (was: page-level MFA gate in the financial-DD page).
 *
 * The VONK background comes from `<RootLayout/>`. All founder-facing copy is
 * English (2026-07-14 policy).
 */
export function FounderLayout() {
  const { signOut } = useAuth()

  return (
    <div className="flex min-h-svh flex-col">
      <header className="flex items-center justify-between gap-4 px-6 py-4">
        <Link
          to="/founder"
          aria-label="Founder home"
          className="rounded-md transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        >
          <img src={logoWhite} alt="VONK Ventures" className="h-9 w-auto" />
        </Link>
        <button
          type="button"
          aria-label="Sign out"
          onClick={() => void signOut()}
          className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-[#ffd9c9] transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        >
          <LogOut className="size-[18px]" />
          Sign out
        </button>
      </header>
      <main className="flex-1 p-6">
        <FounderMfaGate>
          <Suspense fallback={<PageNote>Bezig met laden…</PageNote>}>
            <Outlet />
          </Suspense>
        </FounderMfaGate>
      </main>
    </div>
  )
}
